import { useId, type ReactNode } from 'react';

export interface FormFieldControl {
  readonly id: string;
  /** The error's id while there is one — for the control's `aria-describedby`. */
  readonly describedBy?: string;
  readonly invalid: boolean;
}

export interface FormFieldProps {
  label: string;
  /** Shown while there is no error. */
  hint?: string;
  /** The problem with the value, once the step has been tried. */
  error?: string;
  children: (control: FormFieldControl) => ReactNode;
}

/** A labelled field of the China Payment request (MYP-109), with its hint or its error. */
export function FormField({ label, hint, error, children }: FormFieldProps) {
  const id = useId();
  const messageId = useId();

  return (
    <div className="min-w-0">
      <label htmlFor={id} className="mb-1.5 block text-sm text-muted">
        {label}
      </label>
      {children({
        id,
        ...(error || hint ? { describedBy: messageId } : {}),
        invalid: Boolean(error),
      })}
      {error ? (
        <p id={messageId} className="mt-1.5 text-xs text-danger">
          {error}
        </p>
      ) : hint ? (
        <p id={messageId} className="mt-1.5 text-xs text-muted">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
